import type { ReactNode } from 'react';
import React from 'react';

import { SplitScreenLayoutWrapper } from './styled.tsx';

interface Props {
    imageSide: ReactNode;
    contentSide: ReactNode;
}

const SplitScreenLayout: React.FC<Props> = ({ imageSide, contentSide }) => (
    <SplitScreenLayoutWrapper>
        <div id="image-side">{imageSide}</div>
        <div id="content-side">{contentSide}</div>
    </SplitScreenLayoutWrapper>
);

export default SplitScreenLayout;
